var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgImgPrivato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.175,
    height: 84.967,
    viewBox: "0 0 85.175 84.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_5",
    "data-name": "Ellisse 5",
    cx: 41.5,
    cy: 56.5,
    rx: 41.5,
    ry: 56.5,
    transform: "translate(1138 594.602)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_2",
    "data-name": "Gruppo di maschere 2",
    transform: "translate(-1138 -594.602)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Listen-Music",
    transform: "translate(1139.693 600.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37",
    "data-name": "Tracciato 37",
    d: "M143.93,204.452c-2.812,2.389-12.779,16.519-20.15,25.129-5.543,6.468-.089,16.293,8.34,9.65,5.86-4.621,17.038-18.189,19.4-22.223C155.062,210.966,149.179,199.99,143.93,204.452Z",
    transform: "translate(-104.897 -166.083)",
    fill: "#899b3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_38",
    "data-name": "Tracciato 38",
    d: "M47.119,143.554c.044-1.307,2.546-4.08,2.509-6.379a33.983,33.983,0,0,1,0-5.813c.293-1.689-1.509-2.007-2.509-.338a7.058,7.058,0,0,0-.608,4.1,5.263,5.263,0,0,1-1.872-3.74c4.485-.564,3.9-3.358,2.885-3.4-.9-.044-2.164,0-2.164,0a11.073,11.073,0,0,0,2.164-2.1c1.623-2.1-.226-3.538-.992-2.839s-3.447,2.883-4.169,3.358-.5,1.577-.5,1.577c-1.419-.091-2.772.608-2.636,2.073a1.611,1.611,0,0,0-2.316,1.669A2.237,2.237,0,0,0,35.608,135a29.41,29.41,0,0,0,3.177,6.041,6.969,6.969,0,0,1,1.8,3.38C41.169,149.167,46.961,148.4,47.119,143.554Z",
    transform: "translate(-35.335 -101.083)",
    fill: "#ffb796",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_39",
    "data-name": "Tracciato 39",
    d: "M48.86,169.668a1.547,1.547,0,0,0,2.21-1.6c.9.54,2.3-.54,1.87-2.187a9.623,9.623,0,0,0-2.48-3.561",
    transform: "translate(-46.25 -132.921)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_40",
    "data-name": "Tracciato 40",
    d: "M47.963,174.334a17.954,17.954,0,0,0-2.953-4.3",
    transform: "translate(-43.143 -139.143)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_41",
    "data-name": "Tracciato 41",
    d: "M72.7,149.13H69.18",
    transform: "translate(-62.648 -122.277)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_42",
    "data-name": "Tracciato 42",
    d: "M72,165.953a9.746,9.746,0,0,1-2.818-.193",
    transform: "translate(-62.648 -135.698)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_43",
    "data-name": "Tracciato 43",
    d: "M62.653,223.351c-.676-.834-7.73-.046-8.492,1.125s.427,4.08,0,4.891-1.6,1.93-.542,4.374S60.943,249.7,66.936,255.4s11.044-.9,8.228-8.363c-1.06-2.816-4.553-7.8-5.6-10.345-1.691-4.236-2.123-8.226-2.638-9.081-.811-1.4-2.907-.293-3.515-.88S63.464,224.341,62.653,223.351Z",
    transform: "translate(-49.742 -181.894)",
    fill: "#899b3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_44",
    "data-name": "Tracciato 44",
    d: "M117.822,262.616c-1.06-2.816-4.553-7.8-5.6-10.345-1.683-4.231-2.108-8.226-2.629-9.081-.813-1.4-2.909-.293-3.517-.88",
    transform: "translate(-92.426 -197.473)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_45",
    "data-name": "Tracciato 45",
    d: "M239.184,187.754c-5.229-.135-12.756,1.961-14.649,4.169s-1.737,21.524-1.6,31.869c.158,11.088-2.3,17.177-.992,19.314s7.371,2.509,17.241,2.885c9.241.361,17.106-.27,19.27-2.885s.181-12.779.7-18.706c.542-6.153,3.54-24.927,1.083-29.3S247.682,187.99,239.184,187.754Z",
    transform: "translate(-185.617 -153.442)",
    fill: "#899b3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_46",
    "data-name": "Tracciato 46",
    d: "M223.228,246.87c-.473,7.141-.386,17.826-.293,24.654.158,11.09-2.3,17.177-.992,19.316",
    transform: "translate(-185.617 -201.153)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_47",
    "data-name": "Tracciato 47",
    d: "M261.189,162.444a3.316,3.316,0,0,0-3.281,3.088c-.181,2.571,4.395,9.49,6.444,9.781,3.86.542,16.971-6.738,17.49-8.811.2-.745.18-3.449-.564-4.053a7.18,7.18,0,0,0-3.335-1.351s-.158-2.14-1.444-2.727c-2.276-1.036-11.426-1.06-14.875,2.21C261.189,161,261.189,162.444,261.189,162.444Z",
    transform: "translate(-214.946 -129.235)",
    fill: "#6c724e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_48",
    "data-name": "Tracciato 48",
    d: "M327.755,178.55A41.338,41.338,0,0,1,320,187.363",
    transform: "translate(-265.058 -146.019)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_50",
    "data-name": "Tracciato 50",
    d: "M289.455,121.271a32.54,32.54,0,0,0,.135-8.724c-.834-7.234,9.106-7.977,8.587-3.38-.72,6.491-.72,8.722,0,12.1a33.53,33.53,0,0,1-8.587,11.673A34.018,34.018,0,0,1,289.455,121.271Z",
    transform: "translate(-240.056 -87.702)",
    fill: "#ffb796",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_51",
    "data-name": "Tracciato 51",
    d: "M300.834,114.91a2.652,2.652,0,0,1,.135,1.218c-.112,1.013-.193,1.915-.293,2.727-1.284,5-6.265,8.226-8.226,7.572a24.1,24.1,0,0,0,.135-3.088Z",
    transform: "translate(-242.826 -94.662)",
    fill: "#dc8257",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_52",
    "data-name": "Tracciato 52",
    d: "M247.342,146.356c1.33-6.265-2.052-21.119,0-26.776",
    transform: "translate(-205.876 -98.43)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_53",
    "data-name": "Tracciato 53",
    d: "M245.5,89c-2.11.041-3.028,5.626-.762,6.446s2.872-1.93,2.872-3.574C247.609,90.393,247.14,88.986,245.5,89Z",
    transform: "translate(-203.257 -73.752)",
    fill: "#5c5c5c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_54",
    "data-name": "Tracciato 54",
    d: "M239.593,23.951c-1.5.409-2.636-.255-2.09-1.915-2.316.039-2.872-.859-1.21-3.2-3.341-.021-3.322-1.583.905-5.118,4.395-3.667,14.414-5.311,19.708,0,6.074,6.093,1.581,15.664-1.583,17.911Z",
    transform: "translate(-195.573 -10.259)",
    fill: "#4f1700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_55",
    "data-name": "Tracciato 55",
    d: "M252.308,56.97S249.8,66.851,251.235,70.6c1.756,4.551,10.115,7.05,15.742-1.953,4.246,1.094,3.984-5.273.469-3.574.214-.116-.193-8.222-.469-8.106-3.574.9-5.821.965-4.121-1.563-5.391,3.594-9.071,3.789-5.294-1.094C255.413,55.777,253.534,56.833,252.308,56.97Z",
    transform: "translate(-209.207 -45.758)",
    fill: "#ffb796",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_56",
    "data-name": "Tracciato 56",
    d: "M261.976,99.46c-.7,1.992-1.328,1.641-1.9,2.538a1.072,1.072,0,0,0,1.158,1.368",
    transform: "translate(-216.648 -82.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_57",
    "data-name": "Tracciato 57",
    d: "M280.51,132.464c1.641,0,2.656-.527,3.125-1.544",
    transform: "translate(-233.19 -107.582)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_58",
    "data-name": "Tracciato 58",
    d: "M298.32,95.92c.019,1.386,1.992,2.264,2.617.683",
    transform: "translate(-247.563 -79.337)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_59",
    "data-name": "Tracciato 59",
    d: "M260.553,91.219c-.82,1.133-1.93.82-1.953-.019",
    transform: "translate(-215.509 -75.528)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_60",
    "data-name": "Tracciato 60",
    d: "M307.63,74.765a2.08,2.08,0,0,1,2.6,1.9",
    transform: "translate(-255.076 -62.187)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_61",
    "data-name": "Tracciato 61",
    d: "M264.04,70.935c-.508-.859-1.6-.274-1.93.351",
    transform: "translate(-218.341 -58.826)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_62",
    "data-name": "Tracciato 62",
    d: "M320.212,27.343c2.4-7.832,1.855-15.645-5.8-17.343,8.554.919,11.231,8.2,8.046,18.106Z",
    transform: "translate(-260.547 -10)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_63",
    "data-name": "Tracciato 63",
    d: "M332.771,96.986c-2.05.82-3.221,5.919-2.206,7.618.625,1.056,2.48,1.035,3.474.625,1.544-.645,3.067-5.138,1.93-7.012A2.938,2.938,0,0,0,332.771,96.986Z",
    transform: "translate(-273.284 -80.092)",
    fill: "#5c5c5c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64",
    "data-name": "Tracciato 64",
    d: "M363.135,227.807c1.241,3.9,4.732,11.989,5.927,16.363,2.436,8.992,15.485,9.556,12.711-3.314-1.847-8.564-5.678-19.787-8.023-24.319S359.394,216.088,363.135,227.807Z",
    transform: "translate(-299.29 -175.217)",
    fill: "#899b3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_65",
    "data-name": "Tracciato 65",
    d: "M366.13,282.48c1.241,3.9,4.732,11.989,5.927,16.363",
    transform: "translate(-302.285 -229.89)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_66",
    "data-name": "Tracciato 66",
    d: "M307.44,327.118c-5.476.2-17.444-1.644-19.968-1.668-1.465,0-1.691.542-2.546,1.668-.407.519-2.254-.193-3.179.386-1.06.654-1.78,6.085-.743,7.46.517.676,3.358.7,3.628,1.172.517.965.5,2.638,2.839,3.132s20.082,2.229,25.04.571C317.559,338.1,315.779,326.826,307.44,327.118Z",
    transform: "translate(-233.182 -264.567)",
    fill: "#899b3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_67",
    "data-name": "Tracciato 67",
    d: "M325.944,327.118c-5.476.2-17.444-1.644-19.968-1.668-1.465,0-1.691.542-2.546,1.668",
    transform: "translate(-251.686 -264.567)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_68",
    "data-name": "Tracciato 68",
    d: "M283.22,374.61c.519.677,3.358.7,3.63,1.173.517.965.494,2.636,2.839,3.132s20.073,2.231,25.039.564",
    transform: "translate(-235.377 -304.238)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_69",
    "data-name": "Tracciato 69",
    d: "M209.246,283.913c-.654.542-2.457,12.08-2.028,12.982s7.28,3.065,8.106,2.434,2.883-12.215,2.66-13.229S210.094,283.193,209.246,283.913Z",
    transform: "translate(-173.991 -230.918)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_70",
    "data-name": "Tracciato 70",
    d: "M213.5,312.943c-.631-.135-1.8-2.862-2.816-4.08s-2.316-2.073-2.366-1.87c-.068.564-.293,1.758-.452,2.636,0,0-3.314-.631-4.148-.772a36.57,36.57,0,0,1-5.211-1.87c-1.849-.857-2.7.5-2.005,1.158a1.151,1.151,0,0,0-.405,2.185c-.9.068-.992,1.668,1.172,3.291-.405,0-1.511.9.315,2.277a19.875,19.875,0,0,0,4.756,2.681c1.488.473,9.195.924,10.592.9S214.128,313.078,213.5,312.943Z",
    transform: "translate(-164.527 -249.444)",
    fill: "#ffb796",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_71",
    "data-name": "Tracciato 71",
    d: "M286.26,345.535c1.4,0,1.172-6.4.54-6.535",
    transform: "translate(-237.83 -275.501)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_72",
    "data-name": "Tracciato 72",
    d: "M312.926,256.09a70.511,70.511,0,0,1-.046,11.134",
    transform: "translate(-259.312 -208.593)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_73",
    "data-name": "Tracciato 73",
    d: "M271.549,250.84a40.7,40.7,0,0,0-1.216,10.772",
    transform: "translate(-224.945 -204.357)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_74",
    "data-name": "Tracciato 74",
    d: "M216.678,168.053c1.374-4.576-1.442-6.2-2.66,1.283s2.164,29.435-2.953,28.5-3.177-11.194-1.915-18.335a48.707,48.707,0,0,1,7.884-19.273c3.513-4.732,14.333-13.75,16.361-21.5",
    transform: "translate(-174.446 -113.884)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImgPrivato);
export default __webpack_public_path__ + "static/media/SvgImgPrivato.c5b75854351aaedf39973ba365f01c62.svg";
export { ForwardRef as ReactComponent };